import styled from 'styled-components/macro';
import { tabTrackStyles } from '../../common/elements/Staff';

export const AdminNav = styled.nav`
  ${tabTrackStyles}
`;

export * from '../../common/elements/Staff';
